import { render, staticRenderFns } from "./getCoupons.vue?vue&type=template&id=aa7380f0&scoped=true&"
import script from "./getCoupons.vue?vue&type=script&lang=js&"
export * from "./getCoupons.vue?vue&type=script&lang=js&"
import style0 from "./getCoupons.vue?vue&type=style&index=0&id=aa7380f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7380f0",
  null
  
)

export default component.exports